import React, { useMemo } from 'react';
import { Card, Form, Input, Button, Select } from 'antd';
import moment from 'moment';
import './generateReportCard.css';

/**
 * GenerateReportCard renders a form to create a new report.
 */
const GenerateReportCard = ({siteInfo = {}}) => {
  const monthOptions = useMemo(() => {
    const start = moment(siteInfo.commercialOperationDate);
    const end = moment();
    const months = [];

    let current = end.clone();
    while (current.isSameOrAfter(start, 'month')) {
      months.push(current.format('YYYY-MM'));
      current.subtract(1, 'month');
    }

    return months;
  }, [siteInfo.commercialOperationDate]);

  return (
    <Card className="generateReportCard">
      <div className="generateReportHeader">Generate a new report</div>
      <Form
        layout="vertical"
        initialValues={{
          reportMonth: moment('2024-12', 'YYYY-MM').format('YYYY-MM'),
          lineLoss: '0.02',
          prValue: '0.04',
          failureRate: '3%',
          discountRate: '0.68',
          remarks: 'Concentrating more electricity usage between 10:00 and 14:00 can effectively save more on electricity costs.'
        }}
      >
        <div className="formRow">
          <label className="formLabel">Report Month</label>
          <Form.Item name="reportMonth" className="formItemNoMargin">
            <Select dropdownClassName="reportMonthDropdown">
              {monthOptions.map((month) => (
                <Select.Option key={month} value={month}>
                  {month}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </div>
        <div className="formRow">
          <label className="formLabel">Line Loss Value:</label>
          <Form.Item name="lineLoss" className="formItemNoMargin">
            <Input />
          </Form.Item>
        </div>
        <div className="formRow">
          <label className="formLabel">PR Value:</label>
          <Form.Item name="prValue" className="formItemNoMargin">
            <Input />
          </Form.Item>
        </div>
        <div className="formRow">
          <label className="formLabel">Failure Rate:</label>
          <Form.Item name="failureRate" className="formItemNoMargin">
            <Input />
          </Form.Item>
        </div>
        <div className="formRow">
          <label className="formLabel">Estimated Solar Discount Rate:</label>
          <Form.Item name="discountRate" className="formItemNoMargin">
            <Input />
          </Form.Item>
        </div>
        <Form.Item label="Remarks:" name="remarks">
          <Input.TextArea rows={4} />
        </Form.Item>
        <Form.Item>
          <Button type="primary" block className="generateReportButton">
            Generate Report
          </Button>
        </Form.Item>
      </Form>
    </Card>
  );
};

export default GenerateReportCard;
